import { FC, useEffect } from "react"
import { useGeolocated } from "react-geolocated"

interface GeolocationModuleProps {
  onChange: (coords: any, isGeolocationEnabled: boolean) => void
}

const GeolocationModule: FC<GeolocationModuleProps> = ({
  onChange
}) => {

  const { coords, isGeolocationAvailable, isGeolocationEnabled } = useGeolocated({
    positionOptions: {
      enableHighAccuracy: false,
    },
    userDecisionTimeout: 5000,
  })

  useEffect(() => {
    onChange(coords, isGeolocationEnabled)
  }, [coords, isGeolocationEnabled])

  return (
    <></>
  )
}

export default GeolocationModule